import { GlobalState, state as defaultState } from '@/store/modules/global/state';
import { actions } from '@/store/modules/global/actions';
import { mutations } from '@/store/modules/global/mutations';
import { getters } from '@/store/modules/global/getters';
import { Module } from 'vuex';
import { RootState } from '@/store/state';

export default {
  namespaced: true,
  state: defaultState(),
  actions,
  mutations,
  getters
} as Module<GlobalState, RootState>;
